import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Input from '../../../../../components/Form/Input';
import Select from '../../../../../components/Form/Select';
import TextAreaEditor from '../../../../../components/Form/TextAreaEditor';
import { BiMoney } from 'react-icons/bi';
import ButtonHoverAnimated from "../../../../../components/Buttons/ButtonHoverAnimated";
import ImagePicker from '../../../../../components/ImagePicker';
import Notification from '../../../../../components/Notification';
import ButtonBlack from '../../../../../components/Buttons/ButtonBlack';
import DropdownCheckbox from '../../../../../components/Dropdown/DropdownCheckbox';
import {  JOB_API_END_POINT } from "../../../../../utils/constant";
import { PATH_END_POINT } from '../../../../../../api';

const Edit = () => {
  const { id } = useParams(); // Récupérer l'ID de l'offre
  const navigate = useNavigate(); // Pour redirection après mise à jour
  const [errors, setErrors] = useState({});
  const [showNotif, setShowNotif] = useState({
    show: false,
    message: "Enregistrement effectué avec succès !",
    variant: "success",
  });
  const [formValues, setFormValues] = useState(null);
  const [formValues2, setFormValues2] = useState(null);

  // Fonction pour récupérer les données existantes
  useEffect(() => {
    const fetchJobOffer = async () => {
      try {
        const response = await axios.get(`${JOB_API_END_POINT}/detail/${id}`);
        console.log("Données reçues :", response.data); // Vérifiez ici
        setFormValues((prevValues) => ({ ...prevValues, ...response.data }));
        setFormValues2(response.data);
        console.log("Form Values mis à jour :", formValues, formValues2);
      } catch (error) {
        console.error("Erreur lors de la récupération de l'offre :", error);
      }
    };

    fetchJobOffer();
  }, [id]);

  // Vérifier les mises à jour de formValues
  // useEffect(() => {
  //   console.log("Form Values mis à jour :", formValues, formValues2);
  // }, [formValues]);

  // Gestion du changement des champs de texte
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
    setFormValues2((prevValues) => ({ ...prevValues, [name]: value }));
  };

  // Gestion du changement d'image
  const handleImageChange = (imageFile) => {
    if (imageFile instanceof File) {
      setFormValues((prevValues) => ({ ...prevValues, image: imageFile }));
      setFormValues2((prevValues) => ({ ...prevValues, image: imageFile }));
    }
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    // e.preventDefault();

    const data = new FormData();
    Object.keys(formValues2).forEach((key) => {
      if (key === "image" && formValues2?.image instanceof File) {
        data.append(key, formValues2?.image);
      } else {
        data.append(key, formValues2[key]);
      }
    });
    data.forEach((el, index)=>console.log(el, index))
    try {
      const response = await axios.post(`${JOB_API_END_POINT}/update/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setShowNotif({
        show: true,
        message: response.data.message,
        variant: "success",
      });

      // Optionnel : redirection après mise à jour
      // navigate("/some-route");
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'offre d'emploi:", error);
      setShowNotif({
        show: true,
        message: "Erreur lors de la mise à jour de l'offre d'emploi.",
        variant: "error",
      });
    }
  };

  return (
    <div className='min-h-full w-full pr-6 lg:pr-20 xl:pr-40 pl-6 text-primary-black py-6'>
      <div className="flex justify-between items-center mb-4">
        <h1 className='font-semibold'>Modifier une offre</h1>
        <ButtonHoverAnimated
          onClick={(e)=>handleSubmit(e)}
          className='border bg-neutral-200 text-sm rounded-md px-6 py-2 text-white'
        >
          Publier
        </ButtonHoverAnimated>
      </div>

      <form onSubmit={(e)=>handleSubmit(e)} className="space-y-4">
        {/* {formValues?.job_title} */}
      <Input label="Titre de l'offre" name="job_title" value={formValues?.job_title} onChange={handleChange} 
      // onFocus={handleFocus} onBlur={handleBlur} 
      error={errors.job_title} 
      />
      <Select label="Type d'emploi" name="contract_type" options={["CDI", "CDD"]} value={formValues?.contract_type} onChange={handleChange} 
      // onFocus={handleFocus} onBlur={handleBlur} 
      error={errors.contract_type} />
      <Select label="Mode de travail" name="working_method" options={["Présentiel", "Télétravail"]} value={formValues?.working_method} onChange={handleChange} 
      // onFocus={handleFocus} onBlur={handleBlur} 
      error={errors.working_method} />
      <Input label="Durée" name="duration" value={formValues?.duration} onChange={handleChange} />
      <Select label="Catégorie" name="category" options={["Informatique", "Marketing"]} value={formValues?.category} onChange={handleChange} 
      // onFocus={handleFocus} onBlur={handleBlur} 
      error={errors.category} />
      <Input label="Date d'expiration" name="appli_end_at" type="date" value={formValues?.appli_end_at?.split(" ")[0]}  onChange={handleChange} 
      // onFocus={handleFocus} onBlur={handleBlur} 
      error={errors.appli_end_at} />
      <ImagePicker label="Image" handleImage={handleImageChange} initialImage={PATH_END_POINT + formValues2?.image} />
      {/* {PATH_END_POINT +" "+ formValues2?.image} */}

      

      <h3 className="font-semibold text-start mb-4">Critères de sélection</h3>
      <div className="grid grid-cols-3 gap-4">
        <Input label="Niveau de diplôme" name="required_profile" value={formValues?.required_profile} onChange={handleChange} 
        // onFocus={handleFocus} onBlur={handleBlur} 
        error={errors.required_profile} />
        {/* <DropdownCheckbox label='Compétence réquise' className="col-span-2" 
        // valueSlelected={formValues?.required_skills} 
        setValuesSelected={(value) => setFormValues2({ ...formValues2, required_skills: value })} 
        /> */}
         <DropdownCheckbox label='Compétence réquise' valueSlelected={formValues?.required_skills || []} className="col-span-2" setValuesSelected={(value) => setFormValues({ ...formValues, required_skills: value })} />
      </div>

      <h3 className="font-semibold text-start mb-4">Salaire</h3>
      <div className="grid grid-cols-3 gap-4 items-center">
        {["A préciser", "A négocier", "Aucun"].map((option) => (
          <label key={option} className="bg-neutral-50 border rounded-md p-2 gap-2 flex items-center">
            <input type="radio" name="salaryType" value={option} checked={formValues?.salaryType === option} onChange={handleChange} className="w-4 h-4" />
            <div className="flex flex-col justify-center space-y-2">
              <p>{option}</p>
            </div>
          </label>
        ))}
      </div>

      {formValues?.salaryType === "A préciser" && (
        <Input type="number" label="Salaire à payer (en Ariary)" name="salary" value={formValues?.salary} onChange={handleChange} 
        // onFocus={handleFocus} onBlur={handleBlur} 
        error={errors.salary} />
      )}

      <TextAreaEditor label="Description" value={formValues?.description} setValue={(value) => setFormValues2({ ...formValues, description: value })} />
      <TextAreaEditor label="Responsabilité" value={formValues?.mission} setValue={(value) => setFormValues2({ ...formValues, mission: value })} />
      <TextAreaEditor label="Avantage" value={formValues?.benefit} setValue={(value) => setFormValues2({ ...formValues, benefit: value })} />

      <h3 className="font-semibold text-start mb-4">Localisation</h3>
      <div className="grid gap-4">
        <Input label="Adresse" name="address" value={formValues?.address} onChange={handleChange} 
        // onFocus={handleFocus} onBlur={handleBlur} 
        error={errors.address} />
        {/* <Select label="Région" name="region" options={["Antananarivo", "Fianarantsoa"]} value={formValues?.region} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.region} />
        <Select label="District" name="district" options={["Ambohidratrimo", "Antsirabe"]} value={formValues?.district} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.district} /> */}
      </div>

      {/* <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md">Soumettre</button> */}
    </form>

      {/* Notification de succès ou d'erreur */}
      <Notification
        isOpen={showNotif.show}
        setIsOpen={() => setShowNotif({ ...showNotif, show: false })}
        text={showNotif.message}
        variant={showNotif.variant}
      />
    </div>
  );
}

export default Edit;
